export default "<p>ratings works!</p>\r\n";